const projectsType = {
  PROJECTS_TABLE_STATE_SET: 'PROJECTS/TABLE_STATE_SET',
  PROJECTS_TABLE_STATE_RESET: 'PROJECTS/TABLE_STATE_RESET',
};
export default projectsType;
